import { useState, useEffect } from 'react';
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';

const NoLoginDialog = ({ onLoginChange }) => {
    const [newPassword, setNewPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    const handleChange = (e, type) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');

        if (type === 'Phone') {
            setPhone(numericValue);
        } else if (type === 'Email') {
            const maxLength = 50;
            const err = {};
            if (value.length <= maxLength) {
                setEmail(value);
            }
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                err.email = 'Please enter a valid email address.';
            } else {
                err.email = '';
            }
            setErrors(err);
        }
    };
    useEffect(() => {
        if (onLoginChange) {
            onLoginChange(phone, email, newPassword);
        }
    }, [newPassword, phone, email]);

    return (
        <div className="p-d-flex p-flex-column">
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="phone">Phone No.<span style={{ color: "red" }}>*</span></label>
                    <InputText
                        // className="p-mt-2 p-w-100"
                        id="phone"
                        type="text"
                        value={phone}
                        maxLength={10}
                        onChange={(e) => handleChange(e, 'Phone')}
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.phone ? errors.phone : null}
                    </span>
                </div>
            </div>
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="email">Email<span style={{ color: "red" }}>*</span></label>
                    <InputText
                        // className="p-w-100"
                        id="email"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => handleChange(e, 'Email')}
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.email ? errors.email : null}
                    </span>
                </div>
            </div>
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="newPassword" >Password<span style={{ color: "red" }}>*</span></label>
                    <Password
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        toggleMask
                        feedback={false}
                        maxLength={20}
                        className="p-mt-2 p-w-100"
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.newPassword ? errors.newPassword : null}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default NoLoginDialog;
